// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__EQ7vw","primary":"Button_primary__CYB0e","secondary":"Button_secondary__tVGm0"};